import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import IndexInfo from '../pages/mine/IndexInfo.vue'/* 菜单 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import RechargeList from '../pages/mine/RechargeList.vue'/* 充值记录 */

import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import Details from '../pages/mine/details'

Vue.use(VueRouter)

const SITE_TITLE = '惑夜俱樂部'

const routes = [
  { path: '/', redirect: '/Home', component: Home, meta: { title: SITE_TITLE } },
  { path: '/Home', name: 'home', component: Home, meta: { title: SITE_TITLE } },
  { path: '/Choose', name: 'choose', component: Choose, meta: { title: SITE_TITLE } },
  { path: '/List', name: 'list', component: List, meta: { title: SITE_TITLE } },
  { path: '/Profile', name: 'profile', component: Profile, meta: { title: SITE_TITLE } },
  { path: '/Mine', name: 'mine', component: Mine, meta: { title: SITE_TITLE } },
  { path: '/Video', name: 'video', component: Video, meta: { title: SITE_TITLE } },
  { path: '/Game', name: 'game', component: Game, meta: { title: SITE_TITLE } },
  { path: '/Login', name: 'login', component: Login, meta: { title: SITE_TITLE } },
  { path: '/Register', name: 'register', component: Register, meta: { title: SITE_TITLE } },
  { path: '/ServiceOnline', name: 'ServiceOnline', component: ServiceOnline, meta: { title: SITE_TITLE } },
  { path: '/ServicePage', name: 'ServicePage', component: ServicePage, meta: { title: SITE_TITLE } },
  { path: '/Setting', name: 'Setting', component: Setting, meta: { title: SITE_TITLE } },
  { path: '/Infomation', name: 'Infomation', component: Infomation, meta: { title: SITE_TITLE } },
  { path: '/IndexInfo', name: 'IndexInfo', component: IndexInfo, meta: { title: SITE_TITLE } },
  { path: '/Setname', name: 'Setname', component: Setname, meta: { title: SITE_TITLE } },
  { path: '/Setsex', name: 'Setsex', component: Setsex, meta: { title: SITE_TITLE } },
  { path: '/Language', name: 'Language', component: Language, meta: { title: SITE_TITLE } },
  { path: '/Recharge', name: 'Recharge', component: Recharge, meta: { title: SITE_TITLE } },
  { path: '/RechargeList', name: 'RechargeList', component: RechargeList, meta: { title: SITE_TITLE } },

  { path: '/SetPayPassword', name: 'SetPayPassword', component: SetPayPassword, meta: { title: SITE_TITLE } },
  { path: '/SetLoginPassword', name: 'SetLoginPassword', component: SetLoginPassword, meta: { title: SITE_TITLE } },
  { path: '/Lottery', name: 'Lottery', component: Lottery, meta: { title: SITE_TITLE } },
  { path: '/Notice', name: 'Notice', component: Notice, meta: { title: SITE_TITLE } },
  { path: '/PlayVideo', name: 'PlayVideo', component: PlayVideo, meta: { title: SITE_TITLE } },
  { path: '/Setbank', name: 'Setbank', component: Setbank, meta: { title: SITE_TITLE } },
  { path: '/BindCard', name: 'BindCard', component: BindCard, meta: { title: SITE_TITLE } },
  { path: '/Withdraw', name: 'Withdraw', component: Withdraw, meta: { title: SITE_TITLE } },
  { path: '/Personalreport', name: 'Personalreport', component: Personalreport, meta: { title: SITE_TITLE } },
  { path: '/WithdrawRecord', name: 'WithdrawRecord', component: WithdrawRecord, meta: { title: SITE_TITLE } },
  { path: '/GameRecord', name: 'GameRecord', component: GameRecord, meta: { title: SITE_TITLE } },
  { path: '/detail', name: 'Details', component: Details, meta: { title: SITE_TITLE } }
]

//生成路由实例
const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  document.title = (to.matched && to.matched[0] && to.matched[0].meta && to.matched[0].meta.title)
    ? to.matched[0].meta.title
    : SITE_TITLE
  next()
})

export default router
